import { Spin, Tag, TagProps } from "antd";
import React, { FC } from "react";
import Icon from "../assets/icons/icon";
import { getSavedEnums } from "../services/authService";
import { EnumItemType } from "../types/appTypes";
import hexToRGB from "../utilities/colorUtil";
import RingLoader from "./ringLoader";

export interface StatusTagProps extends TagProps {
  status?: EnumItemType | null;
  statusId?: number | null;
  solid?: boolean;
  size?: "small" | "large";
  locked?: boolean;
  loading?: boolean
}

const StatusTag: FC<StatusTagProps> = ({ status, style, statusId, locked, solid, size, color, loading, children, ...rest }) => {
  if (statusId) {
    status = getSavedEnums()?.status.find((st) => st.id === statusId);
  }
  const { icon, onClick } = rest;
  let styles: React.CSSProperties = {
    cursor: onClick ? "pointer" : "default",
    paddingLeft: loading ? "32px" : size === "small" ? "10px" : "18px",
    paddingRight: size === "small" ? "10px" : "18px",
    paddingTop: size === "small" ? "2px" : "5px",
    paddingBottom: size === "small" ? "2px" : "5px",
    marginRight: 0,
    ...style
  };

  if (solid || status?.color) {
    styles.color = solid ? "#fff" : status?.color;
    styles.backgroundColor = solid ? status?.color || color : hexToRGB(status?.color || color || "", 0.2);
  }

  return (
    <Tag
      style={styles}
      color={!status ? color : undefined}
      icon={locked ? <Icon name="lock-closed-outline" size="medium" /> : icon}
      {...rest}
    >
      {loading && (
        <RingLoader size="large"
          style={{ position: "absolute", left: 10, top: '50%', transform: "translateY(-50%)" }}
        />
      )}
      {status?.title ? status.title : children}
    </Tag>
  );
};

export default StatusTag;
